/** Join origin/base + path without duplicating slashes. */
export function joinUrl(base: string, path: string): string {
  const root = base.replace(/\/+$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  if (!root) return suffix;
  return `${root}${suffix}`;
}
